import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getContractors } from "common/services/contractors.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";

const SelectContractorAfiliatedTo = ({
  validation,
  selectedId,
  index,
}: {
  validation: any;
  isUpdate?: boolean;
  selectedId?: number;
  index: number;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation?.touched?.affiliations?.[index]?.affiliatedTo &&
        validation?.errors?.affiliations?.[index]?.affiliatedTo
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation?.touched?.affiliations?.[index]?.affiliatedTo &&
          validation?.errors?.affiliations?.[index]?.affiliatedTo
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getContractors({
          pagination: {
            page: 1,
            pageSize: 20,
          },
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedId]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.contractorName || ""}`,
      };
    });
  }, [data]);

  return (
    <FormGroup key={index}>
      <Label
        htmlFor={`affiliations.${index}.affiliatedTo`}
        className="form-label"
      >
        Affiliated To Contractor
      </Label>
      <Select
        name={`affiliations.${index}.affiliatedTo`}
        id={`affiliations.${index}.affiliatedTo`}
        value={
          validation.values.affiliations[index].affiliatedTo.value
            ? validation.values.affiliations[index].affiliatedTo
            : null
        }
        placeholder="Select affiliatedTo"
        onChange={(value: any) => {
          validation.setFieldValue(`affiliations.${index}.affiliatedTo`, value);
          validation.setFieldError(`affiliations.${index}.affiliatedTo`, "");
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getContractors({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  affiliatedTo: {
                    contractorName: {
                      $containsi: inputValue,
                    },
                  },
                },
              ],
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.contractorName || ""}`,
                };
              })
            );
          });
        }}
        onBlur={() =>
          validation.setFieldTouched(`affiliations.${index}.affiliatedTo`, true)
        }
        className={
          validation.touched.affiliations?.[index]?.affiliatedTo &&
          validation.errors.affiliations?.[index]?.affiliatedTo
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>
        {validation.errors.affiliations?.[index]?.affiliatedTo?.value}
      </FormFeedback>
    </FormGroup>
  );
};

export default SelectContractorAfiliatedTo;
